import _ from 'lodash';
import CHATED from '../../../helpers/chated-client';
import Graph from '../../../helpers/graph';
import {
	GET_TEMPLATE_CONNECTION_STATISTICS,
	ERROR_TEMPLATE_CONNECTION_STATISTICS,

	RESET_ALERT_MESSAGE,
	RESET
} from '../../../constants';

export function resetAlertMessage() {
	return async (dispatch) => {
		dispatch({
			type: RESET_ALERT_MESSAGE
		});
	};
}

export function reset() {
	return async (dispatch) => {
		dispatch({
			type: RESET
		});
	};
}

export function getTemplateConnectionStatistics(id, startDate, endDate) {
	return async (dispatch) => {
		const response = await CHATED.templateConnectionStatistic.getAll({
			template_connection_id: id,
			start_date: startDate,
			end_date: endDate
		});

		if (response.meta.code !== 200) {
			dispatch({
				type: ERROR_TEMPLATE_CONNECTION_STATISTICS,
				meta: response.meta
			});

			return;
		}

		const templateConnectionStatistics = Graph.statistics(response.data.template_connection_statistics);

		if (!_.isNil(templateConnectionStatistics)) {
			dispatch({
				type: GET_TEMPLATE_CONNECTION_STATISTICS,
				meta: null,
				templateConnectionStatistics
			});
		} else {
			dispatch({
				type: ERROR_TEMPLATE_CONNECTION_STATISTICS,
				meta: response.meta
			});
		}
	};
}



// WEBPACK FOOTER //
// ./src/containers/dashboard-emails-statistics-page/actions/index.js